import React, { Component, RefObject } from 'react';
import Icon from '../../../icons/Icon';
import { FormicaTimePickerDate } from './TimePickerDomain';

class CustomTimePickerFooter extends Component<Props> {
  private readonly scrollContainerRef: RefObject<HTMLDivElement> | null = null;

  constructor(props: Props) {
    super(props);
    this.scrollContainerRef = React.createRef<HTMLDivElement>();
  }

  render() {
    const times = [
      '08:00',
      '08:30',
      '09:00',
      '09:30',
      '10:00',
      '10:30',
      '11:00',
      '11:30',
      '12:00',
      '12:30',
      '13:00',
      '13:30',
      '14:00',
      '14:30',
      '15:00',
      '15:30',
      '16:00',
      '16:30',
      '17:00',
      '18:00',
      '19:30',
      '20:00',
      '20:30',
      '21:00',
      '21:30',
      '22:00',
      '22:30',
      '23:00',
      '23:30',
      '00:00',
      '00:30',
      '01:00',
      '02:00',
      '03:00',
      '04:00',
      '05:00',
      '06:00',
      '07:00',
    ];
    return (
      <div className={'flex items-center justify-between w-full h-full gap-x-5'}>
        <div onClick={this.scrollLeft} className={'w-1/8 flex cursor-pointer'}>
          <Icon icon={'arrow-left'} size={20} />
        </div>
        <div ref={this.scrollContainerRef} className={'flex items-center overflow-x-scroll'}>
          {times.map((time, index) => {
            return (
              <div key={index} onClick={() => this.setHour(time)} className={'text-md text-f-black-4 hover:text-f-black-2 flex hover:cursor-pointer ml-1 mr-1'}>
                {time}
              </div>
            );
          })}
        </div>
        <div onClick={this.scrollRight} className={'w-1/8 flex cursor-pointer'}>
          <Icon icon={'arrow-right'} size={20} />
        </div>
      </div>
    );
  }

  private scrollLeft = () => {
    const scrollContainer = this.scrollContainerRef?.current;
    if (scrollContainer) {
      scrollContainer.scrollBy({ left: -200, behavior: 'smooth' });
    }
  };

  private scrollRight = () => {
    const scrollContainer = this.scrollContainerRef?.current;
    if (scrollContainer) {
      scrollContainer.scrollBy({ left: 200, behavior: 'smooth' });
    }
  };

  private getDateFromHour(hourString: string): Date {
    const { date } = this.props;
    const [hours, minutes] = hourString.split(':').map((str) => parseInt(str, 10));
    if (date.value instanceof Date) {
      return new Date(date.value.getFullYear(), date.value.getMonth(), date.value.getDate(), hours, minutes);
    }
    return new Date();
  }

  private setHour = (hourString: string) => {
    const { setDate } = this.props;
    setDate({ value: this.getDateFromHour(hourString), label: this.getDateFromHour(hourString).toLocaleString(), type: 'Absolute' });
  };
}

interface Props {
  date: FormicaTimePickerDate;
  setDate: (date: FormicaTimePickerDate) => void;
}

// write an array variable for times like ["08:00","08:30","09:00"]

export default CustomTimePickerFooter;
